<script>
  /**
   * @typedef {Object} TableData
   * @property {array} columnHeaders
   * @property {array} rowData
   */

  /**
   * @type {TableData}
   */
  export let tableData;

  /**
   * @type {string}
   */
  export let tableClass;
</script>

<table class="border-collapse text-left {tableClass}">
  <thead class="font-gotham-condensed text-body-l-small md:text-h6-large">
    <tr>
      {#each tableData.columnHeaders as columnHeader}
        <th class="px-2 py-2 md:px-3.5">{columnHeader}</th>
      {/each}
    </tr>
  </thead><tbody>
    {#each tableData.rowData as row}
      <tr class="border-t-thin">
        {#each row as cellContent}
          <td
            class="whitespace-pre text-wrap px-2 py-2 pt-5 align-top text-body-s-small md:w-50 md:px-3.5 md:text-body-m-small"
          >
            {cellContent}
          </td>
        {/each}
      </tr>
    {/each}
  </tbody>
</table>
